/**
 * Cloud Retail attribution — one session cookie shared across tabs (cleared when browser closes).
 * URL params (cr_at, cr_pid, cr_region) seed the cookie when a product opens in a new tab.
 */
(function () {
  'use strict';

  var COOKIE = 'cloud_retail_session';

  function load() {
    var m = document.cookie.match(new RegExp('(?:^|; )' + COOKIE + '=([^;]*)'));
    if (!m) return { tokens: {}, region: '' };
    try {
      return JSON.parse(decodeURIComponent(m[1]));
    } catch (e) {
      return { tokens: {}, region: '' };
    }
  }

  function save(data) {
    document.cookie = COOKIE + '=' + encodeURIComponent(JSON.stringify(data)) + '; path=/; SameSite=Lax';
  }

  function getToken(productId) {
    return productId ? (load().tokens[String(productId)] || null) : null;
  }

  function getRegion() {
    return load().region || '';
  }

  function setRegion(region) {
    if (!region) return;
    var s = load();
    s.region = region;
    save(s);
  }

  function mergeTokens(products, token) {
    if (!token || !products || !products.length) return;
    var s = load();
    for (var i = 0; i < products.length; i++) {
      var p = products[i];
      if (p && p.id != null && !s.tokens[String(p.id)]) {
        s.tokens[String(p.id)] = token;
      }
    }
    save(s);
  }

  function resetTokens() {
    document.cookie = COOKIE + '=; path=/; Max-Age=0';
  }

  function appendAttributionParams(url, productId) {
    var token = getToken(productId);
    if (!url || !productId || !token) return url;
    try {
      var u = new URL(url, location.origin);
      u.searchParams.set('cr_at', token);
      u.searchParams.set('cr_pid', String(productId));
      var region = getRegion();
      if (region) u.searchParams.set('cr_region', region);
      return u.toString();
    } catch (e) {
      return url;
    }
  }

  function seedFromUrl() {
    var p = new URLSearchParams(location.search);
    var token = p.get('cr_at');
    var productId = p.get('cr_pid');
    if (!token || !productId) return;

    var s = load();
    s.tokens[String(productId)] = token;
    if (p.get('cr_region')) s.region = p.get('cr_region');
    save(s);

    p.delete('cr_at');
    p.delete('cr_pid');
    p.delete('cr_region');
    var qs = p.toString();
    history.replaceState(null, '', location.pathname + (qs ? '?' + qs : '') + location.hash);
  }

  function openProductLink(url, productId) {
    window.open(appendAttributionParams(url, productId), '_blank', 'noopener,noreferrer');
  }

  window.CloudRetailAttribution = {
    mergeTokens: mergeTokens,
    resetTokens: resetTokens,
    getToken: getToken,
    getRegion: getRegion,
    setRegion: setRegion,
    appendAttributionParams: appendAttributionParams,
    openProductLink: openProductLink,
  };

  seedFromUrl();
})();
